import { GovIcon } from '@gov-design-system-ce/react';
import type { GovIconProps } from '@gov-design-system-ce/react/dist/gov-icon/GovIcon';

interface IconColored {
	type: 'colored';
	name: 'lev' | 'logo' | 'logo-white' | 'flag-eng' | 'flag-cze';
}

interface IconComplex {
	type: 'complex';
	name: 'confusion' | 'hand';
}

interface IconComponents {
	type: 'components';
	name:
		| 'eye'
		| 'search'
		| 'loader'
		| 'upload'
		| 'info-circle-fill'
		| 'exclamation-triangle-fill'
		| 'chevron-left'
		| 'chevron-up'
		| 'chevron-down'
		| 'chevron-right'
		| 'check-lg'
		| 'geo-alt-fill'
		| 'info-circle'
		| 'envelope'
		| 'envelope-fill'
		| 'send'
		| 'twitter-x'
		| 'in-trezor'
		| 'lightbulb-fill'
		| 'archive'
		| 'x-lg'
		| 'box-arrow-up-right';
}

interface IconTemplates {
	type: 'templates';
	name:
		| 'lion'
		| 'arrow-up'
		| 'youtube'
		| 'facebook'
		| 'list'
		| 'card-500'
		| 'trash'
		| 'star-fill'
		| 'download'
		| 'journal-text'
		| 'star'
		| 'plus-circle'
		| 'plus-lg'
		| 'person-fill'
		| 'briefcase-fill'
		| 'building'
		| 'ovm'
		| 'pencil-square'
		| 'funnel'
		| 'arrow-clockwise'
		| 'caret-down-fill'
		| 'caret-up-fill'
		| 'envelope'
		| 'telephone'
		| 'box-arrow-right'
		| 'bell-fill'
		| 'send'
		| 'send-fill'
		| 'archive'
		| 'archived-outline'
		| 'notification'
		| 'datovka-fill'
		| 'arrow-counterclockwise'
		| 'error'
		| 'briefcase'
		| 'in-trezor'
		| 'person';
}

export type IconProps = (
	| IconComponents
	| IconTemplates
	| IconColored
	| IconComplex
) &
	Pick<GovIconProps, 'color' | 'className' | 'size' | 'slot'> & {
		'aria-label'?: string;
	};

export const Icon = ({
	name,
	type,
	className,
	color,
	size,
	...rest
}: IconProps) => (
	<GovIcon
		{...rest}
		type={type}
		name={name}
		className={className}
		color={color}
		size={size}
	/>
);
